import apiClient from '@/api/client';
import type {
  GeocodeResult,
  GeocodeSuggestListResponse,
  ReverseGeocodeRequest,
} from '@/types/geocode';
import { isAxios404 } from '@/utils/axiosError';

export async function suggestAddresses(
  q: string,
  limit = 10,
): Promise<GeocodeSuggestListResponse> {
  const response = await apiClient.get<GeocodeSuggestListResponse>(
    '/api/v1/geocode/suggest',
    { params: { q, limit } },
  );
  return response.data;
}

export async function geocode(query: string): Promise<GeocodeResult | null> {
  try {
    const response = await apiClient.post<GeocodeResult>('/api/v1/geocode', { query });
    return response.data;
  } catch (error) {
    if (isAxios404(error)) {
      return null;
    }
    throw error;
  }
}

export async function reverseGeocode(
  body: ReverseGeocodeRequest,
): Promise<GeocodeResult | null> {
  try {
    const response = await apiClient.post<GeocodeResult>('/api/v1/reverse-geocode', body);
    return response.data;
  } catch (error) {
    if (isAxios404(error)) {
      return null;
    }
    throw error;
  }
}
